import React, { Fragment, useState } from "react"
import { useTranslation } from "react-i18next"

import { moment } from "utils"
import classes from "./DpFooter.module.scss"

const DpFooter = props => {
  const {
    type,
    timeRange,
    timeRangeStep,
    setTimeRangeStep,
    selectedDate,
    selectedTime,
    setOpenDatePicker,
    onChange,
    selectedRange,
    setSelectedDate,
    setShownDate,
    setSelectedTime,
    setSelectedRange
  } = props

  const [t] = useTranslation()

  const [error, setError] = useState("")

  const handleNow = () => {
    if (type === "rangeDatePicker") {
      setShownDate(moment())

      setSelectedRange(prev => {
        const newRange = [...prev]

        if (!!newRange[0]) {
          return [newRange[0], moment()]
        }

        return [moment()]
      })

      return
    }

    if (type === "datePicker") {
      setShownDate(moment())

      setSelectedDate(moment())

      return
    }

    if (type === "dateAndTimePicker") {
      setShownDate(moment())

      setSelectedDate(moment())

      setSelectedTime({
        hours: moment().get("hours"),
        minutes: moment().get("minutes")
      })

      return
    }
  }

  const handleConfirmRange = () => {
    const resultRange = [...selectedRange]

    if (!resultRange[1]) resultRange[1] = selectedRange[0]

    onChange([
      resultRange[0].toISOString(),
      resultRange[1].endOf("day").toISOString()
    ])

    setOpenDatePicker(false)
  }

  const handleConfirmTime = () => {
    onChange(`${selectedTime.hours}:${selectedTime.minutes}:00`)
  }

  const handleConfirmDate = () => {
    const resultDate = moment(selectedDate)

    type === "dateAndTimePicker" &&
      resultDate.set({
        hours: selectedTime.hours,
        minutes: selectedTime.minutes
      })

    onChange(resultDate.toISOString())

    setOpenDatePicker(false)
  }

  const handleTimeRange = () => {
    if (timeRangeStep === "start")
      return setTimeRangeStep("end")

    if ((Number(timeRange[0].hours) > Number(timeRange[1].hours))) {
      return setError(t("زمان_شروع_از_زمان_پایان_بیشتر_است"))
    } else if (
      Number(timeRange[0].hours) === Number(timeRange[1].hours) &&
      Number(timeRange[0].minutes) > Number(timeRange[1].minutes)
    ) {
      return setError(t("زمان_شروع_از_زمان_پایان_بیشتر_است"))
    }

    onChange([
      `${timeRange[0].hours}:${timeRange[0].minutes}:00`,
      `${timeRange[1].hours}:${timeRange[1].minutes}:00`
    ])

    setOpenDatePicker(false)
  }

  const handleConfirm = () => {
    if (type === "rangeDatePicker") {
      return handleConfirmRange()
    }

    if (type === "timePicker") {
      return handleConfirmTime()
    }

    handleConfirmDate()
  }

  return (
    <div className={classes["footer"]}>
      {
        !!error &&
        <div className={classes["error"]}>
          *{error}
        </div>
      }

      <button
        className={classes["close"]}
        onClick={() => setOpenDatePicker(false)}
      >
        {t("بستن")}
      </button>

      {type === "rangeTimePicker"
        ?
        <button
          className={classes["done"]}
          onClick={handleTimeRange}
        >
          {timeRangeStep === "start" ? t("بعدی") : t("تایید")}
        </button>
        :
        <Fragment>
          <button
            className={classes["done"]}
            onClick={handleConfirm}
          >
            {t("تایید")}
          </button>

          <button
            className={classes["now"]}
            onClick={handleNow}
          >
            {t("اکنون")}
          </button>
        </Fragment>
      }
    </div>
  )
}

export default DpFooter